import React from 'react';
import { Flame, Heart, Quote, Smile, Target } from 'lucide-react';
import StepHeading from './StepHeading';
import ChoiceCard from './ChoiceCard';

interface BuildCommercialStep5Props {
  tone: string;
  setTone: (tone: string) => void;
  loading: boolean;
}

const TONES = [
  {
    id: 'playful',
    title: 'Playful',
    icon: <Smile />,
    description: 'Colour, pace, and a line that makes people smile.',
  },
  {
    id: 'serious',
    title: 'Serious',
    icon: <Target />,
    description: 'Clean, factual, and built to earn trust.',
  },
  {
    id: 'sarcastic',
    title: 'Sarcastic',
    icon: <Quote />,
    description: 'Sharp humour and a turn nobody sees coming.',
  },
  {
    id: 'wholesome',
    title: 'Wholesome',
    icon: <Heart />,
    description: 'Warm, honest moments that feel like family.',
  },
  {
    id: 'edgy',
    title: 'Edgy',
    icon: <Flame />,
    description: 'Dark, bold, and happy to provoke.',
  },
];

const BuildCommercialStep5: React.FC<BuildCommercialStep5Props> = ({ tone, setTone }) => (
  <div className="ed-enter">
    <StepHeading
      index={5}
      kicker="Writers' room"
      title="Give the writers a voice to write in."
      lede="Tone decides how every line lands. One choice, and the whole script follows it."
    />

    <div className="ed-block">
      <div className="ed-grid" role="radiogroup" aria-label="Commercial tone">
        {TONES.map((option) => (
          <ChoiceCard
            key={option.id}
            icon={option.icon}
            title={option.title}
            description={option.description}
            selected={tone === option.id}
            onSelect={() => setTone(option.id)}
          />
        ))}
      </div>
    </div>
  </div>
);

export default BuildCommercialStep5;
